import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Notifications.types'

@Injectable({ providedIn: 'root' })
export class Notifications_auto_email_schedule_format_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { schedule: $types.Notifications.AutoEmailSchedule }): Promise<{ scheduleString?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.schedule)) {
      missingRequiredInParams.push('\'schedule\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/functions/auto_email_schedule_format_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

